import React, { useState } from 'react';
import { observer, inject } from 'mobx-react';
import sanitizeHtml from 'sanitize-html';
import { Button, Modal, PopupArticle } from '@shopee/chatbot-ui';
import { ModalProps } from '@shopee/chatbot-ui/lib/components/Modal/Base';

import { ButtonAction, getButtonAction } from '@/utils/getButtonData';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { INPUT_TYPE } from '@/utils/constants';
import sanitizeHtmlOptions from '@/utils/sanitizeHtmlOptions';
import { updateDialogueInfo } from '@/utils/sessionUtils';
import { InitStoreType } from '@/types/store/init';
import { ActionType } from '@/types/common';

export type GuaranteeModalProps = {
  taskbotInfo: any;
  action: {
    action_type: ButtonAction;
    task_bot_action: any;
  };
  modalProps: {
    title: string;
    content: string;
    read_more: string;
    confirm_value: string;
    refuse_value: string;
  };
  article: {
    title: string;
    content: string;
  };
} & {
  initStore: InitStoreType;
  dialogueId: string;
  threadNodeId: string;
  threadId: string;
  threadIdV2: string;
  roundId: string;
  cardPosition: number;
};

const GuaranteeModal: React.FC<GuaranteeModalProps> = (props) => {
  const [active, setActive] = useState(true);
  const [showArticle, setShowArticle] = useState(false);
  const modalProps = props.modalProps;
  const article = props.article;
  const uiModalProps = {
    active,
    title: modalProps?.title,
    onClose: () => setActive(false),
    footer: {
      layout: 'horizontal',
      buttons: [
        {
          text: modalProps?.refuse_value,
          style: { color: '#000' },
          onClick: () => setActive(false),
        },
        {
          text: modalProps?.confirm_value,
          action: {
            showUserMessage: false,
            func: getButtonAction(ButtonAction.JumpNode),
            info: props,
            nextParams: {
              message_text: modalProps?.confirm_value,
              input_type: INPUT_TYPE.BUTTON,
              session_id: props.initStore.sessionId,
              dialogue_id: props.dialogueId,
              thread_node_id: props.threadNodeId,
              thread_id: props.threadId,
              thread_id_v2: props.threadIdV2,
              round_id: props.roundId,
              is_bypass: true, // guarantee modal 点击 confirm 产生的消息不落库
              message_extra: { task_bot_action: Object.assign({ task_bot_info: props.taskbotInfo }, props?.action?.task_bot_action) },
            },
            callback: (res: any) => {
              if (res?.fe_action?.action_type === ActionType.HideESGButton) {
                updateDialogueInfo({ isExtendGuaranteeDisabled: true }, props.cardPosition);
              }
            },
          },
          onClick: () => setActive(false),
        },
      ],
    },
  };

  return (
    <>
      <Modal {...(uiModalProps as ModalProps)}>
        <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(modalProps?.content, sanitizeHtmlOptions) }}></span>
        <Button
          text={modalProps?.read_more}
          type="frameless"
          onClick={() => setShowArticle(true)}
          style={{
            display: 'inline-block',
            minWidth: 'unset',
            margin: 'unset',
            padding: 'unset',
            marginLeft: '0.5rem',
            color: '#0088FF',
          }}
        />
      </Modal>
      <PopupArticle
        active={showArticle}
        title={article?.title}
        content={article?.content}
        onClose={() => setShowArticle(false)}
      />
    </>
  );
};

export default inject(getChildInject('initStore'))(observer(GuaranteeModal));
